import { memo } from 'react';
import styles from './MoreStatusInformation.module.scss';
import { useNavigateWithSecureParams } from 'src/utils/hooks/useNavigateWithSecureParams';

/**
 * Component to display more status information text.
 */
const MoreStatusInformation = memo(({ id, country }: { id: number; country?: string }) => {
  const { navigate } = useNavigateWithSecureParams();
  return (
    <div
      className={styles['more-status-information']}
      onClick={() =>
        navigate(`/immigration-status?${country ? `country=${country}` : ''}`, {
          secureParams: {
            id,
          },
        })
      }
    >
      <div className={styles['more-status-information-icon']}></div>
      <span>More status information</span>
    </div>
  );
});

export default MoreStatusInformation;
